import { ReduxAction } from '../../enums/const-enums';

export interface EmailState {
  emailAddress: string;
  isEmailAddressRemembered: boolean;
}

const initialState: EmailState = {
  emailAddress: '',
  isEmailAddressRemembered: false,
};

export interface EmailAction {
  type: ReduxAction;
  payload: EmailState;
}

export function emailReducer(
  state: EmailState = initialState,
  action: EmailAction,
): EmailState {
  switch (action.type) {
    case ReduxAction.SET_EMAIL_ADDRESS:
      state.emailAddress = action.payload.emailAddress;
      break;
    case ReduxAction.SET_IS_EMAIL_ADDRESS_REMEMBERED:
      state.isEmailAddressRemembered = action.payload.isEmailAddressRemembered;
      break;
  }
  return state;
}
